/* ==========================================================================
  main.js
========================================================================== */
window.sr = ScrollReveal();
sr.reveal('.box_container span', {
	delay: 200,
	duration: 500,
	origin: 'left',
	distance: '50px'
});
sr.reveal('.box_container em', {
	delay: 200,
	duration: 500,
	origin: 'left',
	distance: '50px'
});

// navigation
aucor_navigation(document.getElementById('primary-navigation'), {
	desktop_min_width: 501, // min width in pixels
	menu_toggle: '#menu-toggle' // selector for toggle
});

// responsive videos
fitvids();



// add jquery as dependency in functions.php and uncomment the following if you need jquery
//
(function ($) {
	$(document).ready(function () {
		$('.slider').bxSlider({
			controls: false,
		});
	});

})(jQuery);
